<template>
  <div>
    <div>
      <ProfileInfoItem
        label="Navn"
        :value="userInfo.firstName + ' ' + userInfo.lastName"
      />
      <ProfileInfoItem label="Telefon" :value="userInfo.telephone" />
      <ProfileInfoItem
        label="Går i modul"
        v-if="userInfo.module"
        :value="userInfo.module.name"
      />
      <ProfileInfoItem label="Bosted" :value="userInfo.city" />
      <ProfileInfoItem
        label="Kan jobbe fulltid"
        :value="userInfo.canWorkFullTime ? 'Ja' : 'Nei'"
      />
      <ProfileInfoItem
        label="Pendlevillighet"
        :value="userInfo.canCommute ? 'Ja' : 'Nei'"
      />
      <ProfileInfoItem
        label="Flyttevillighet"
        :value="userInfo.canMove ? 'Ja' : 'Nei'"
      />
      <ProfileInfoItem
        label="Førekort"
        :value="userInfo.hasDriverLicense ? 'Ja' : 'Nei'"
      />
      <ProfileInfoItem
        label="Egen bil"
        :value="userInfo.hasOwnCar ? 'Ja' : 'Nei'"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ProfileInfoItem from "@/components/ProfileInfoItem";
export default {
  name: "PersonaliaComponent",
  components: {
    ProfileInfoItem,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style scoped lang="scss">
</style>